import {UiBaseFilter} from "../UiBaseFilter";
import {formGroup} from "../BaseEditor";
import {CachedPromise} from "../CachedPromise";
import {TreeSelector} from "../TreeSelector";
import {UiTomSelect} from "../components/UiTomSelect";

export class InvoiceApprovingFilter extends UiBaseFilter
{
	// @ts-ignore
	public orgDivisionPromise: CachedPromise<any>;
	// @ts-ignore
	public orgProjectPromise: CachedPromise<any>;
	// @ts-ignore
	public orgProductPromise: CachedPromise<any>;
	// @ts-ignore
	public vendorPromise: CachedPromise<any>;
	// @ts-ignore
	public myBuSubjectPromise: CachedPromise<any>;
	// @ts-ignore
	public ticketTypePromise: CachedPromise<any>;
	// @ts-ignore
	public accountingDocumentTypePromise: CachedPromise<any>;

	beforeIndex() {
		this.wrapFilter(
			formGroup('number', 'Číslo dokladu',
				`<input type="search" class="form-control" mu-bind="number" />`,
				true
			)
			+ formGroup('vendorId', 'Subjekt',
				`<div mu-widget="UiTomSelect" mu-id="vendorId" mu-bind="vendorId"></div>`,
				true
			)
			+ formGroup('buSubjectId', 'Naše firma',
				`<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId"></div>`,
				true
			)
			+ formGroup('orgDivisionId', 'Středisko',
				`<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-bind="orgDivisionId" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`,
				true
			)
			+ formGroup('orgProjectId', 'Projekt',
				`<div mu-widget="UiTomSelect" mu-id="orgProjectId" mu-bind="orgProjectId"></div>`,
				true
			)
			+ formGroup('orgProductId', 'Produkt',
				`<div mu-widget="UiTomSelect" mu-id="orgProductId" mu-bind="orgProductId"></div>`,
				true
			)
			+ formGroup('dtTax', 'DUZP',
				`<div mu-widget="UiDateFilter" mu-bind="dtTax"></div>`,
				true
			)
			+ formGroup('dtDue', 'Splatnost',
				`<div mu-widget="UiDateFilter" mu-bind="dtDue"></div>`,
				true
			)
			+ formGroup('amountWT', 'Částka s DPH',
				`<div mu-widget="UiNumberRange" mu-bind="amountWT"></div>`,
				true
			)
			+ formGroup('amountNT', 'Částka bez DPH',
				`<div mu-widget="UiNumberRange" mu-bind="amountNT"></div>`,
				true
			)
			+ formGroup('orgProjectId', 'Kategorie',
				`<div mu-widget="UiTomSelect" mu-id="ticketTypeId" mu-bind="ticketTypeId"></div>`,
				true
			)
			+ formGroup('orgProjectId', 'Typ dokladu',
				`<div mu-widget="UiTomSelect" mu-id="accountingDocumentTypeId" mu-bind="accountingDocumentTypeId"></div>`,
				true
			)
		);
	}

	async afterIndex() {
		await Promise.all([
			this.orgDivisionPromise.fetch().then(ls => {
				(this.muNamedWidget.orgDivisionId as unknown as TreeSelector).bindTree(ls);
			}),
			this.orgProductPromise.fetch().then(ls => (this.muNamedWidget.orgProductId as unknown as UiTomSelect).init({labelField: "title", multiple: true}).bindItems(ls)),
			this.orgProjectPromise.fetch().then(ls => (this.muNamedWidget.orgProjectId as unknown as UiTomSelect).init({labelField: "title", multiple: true}).bindItems(ls)),
			this.vendorPromise.fetch().then(ls => (this.muNamedWidget.vendorId as unknown as UiTomSelect).init({labelField: "name", multiple: true, searchField:["name","identificationNumber"]}).bindItems(ls)),
			this.myBuSubjectPromise.fetch().then(ls => (this.muNamedWidget.buSubjectId as unknown as UiTomSelect).init({labelField: "name", multiple: true })
				.bindItems([{name:"Nezadáno", value:"null"}, ...ls])
			),
			this.ticketTypePromise.fetch().then(ls => (this.muNamedWidget.ticketTypeId as unknown as UiTomSelect).init({labelField: "name", multiple: true}).bindItems(ls)),
			this.accountingDocumentTypePromise.fetch().then(ls => (this.muNamedWidget.accountingDocumentTypeId as unknown as UiTomSelect)
				.init({labelField: "name", multiple: true})
				.bindItems([{name:"Nezadáno", value:"null"}, ...ls])),

		]);
		super.afterIndex();
	}
}